"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurgerMenu = void 0;
var react_1 = __importDefault(require("react"));
var BurgerMenu_module_scss_1 = __importDefault(require("./BurgerMenu.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var icon_theme_webp_1 = __importDefault(require("../../assets/images/icon_theme.webp"));
var ThemeContext_1 = require("../../context/ThemeContext");
var BurgerMenu = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var handleFollowLink = function () {
        dispatch((0, modalSlice_1.closeModal)('burgerMenu'));
    };
    var menu = (0, react_redux_1.useSelector)(selectors_1.modalSelector).burgerMenu.menuNavigation;
    var menuState = (0, react_redux_1.useSelector)(selectors_1.modalSelector).burgerMenu.modalState;
    var _a = (0, ThemeContext_1.useTheme)(), theme = _a.theme, toggleTheme = _a.toggleTheme;
    return (react_1.default.createElement("nav", { className: "".concat(BurgerMenu_module_scss_1.default.burger_menu, " ").concat(menuState ? BurgerMenu_module_scss_1.default.burger_menu_active : '') },
        react_1.default.createElement("ul", { className: BurgerMenu_module_scss_1.default.burger_menu__list },
            menu.map(function (_a) {
                var name = _a.name, link = _a.link;
                return (react_1.default.createElement("li", { className: BurgerMenu_module_scss_1.default.burger_menu__item, key: name, onClick: handleFollowLink },
                    react_1.default.createElement(react_router_dom_1.Link, { className: BurgerMenu_module_scss_1.default.burger_menu__link, to: link }, name)));
            }),
            react_1.default.createElement("li", { className: "".concat(BurgerMenu_module_scss_1.default.burger_menu__item, " ").concat(BurgerMenu_module_scss_1.default[theme]), style: { display: 'flex', alignItems: 'center' } },
                react_1.default.createElement("span", { style: { padding: '16px' } },
                    ' ',
                    "\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0435\u043C\u0443:"),
                react_1.default.createElement("img", { loading: "lazy", onClick: toggleTheme, id: "theme-icon", className: BurgerMenu_module_scss_1.default.theme_toggle, src: icon_theme_webp_1.default, alt: "Theme Icon", style: { width: '32px', height: '32px', margin: '6px', marginLeft: '6px' } })))));
};
exports.BurgerMenu = BurgerMenu;
